module.exports = __webpack_public_path__ + "static/media/intro.a1ee1f5a.mp3";